'use strict';

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _intersection2 = require('lodash/intersection');

var _intersection3 = _interopRequireDefault(_intersection2);

exports["default"] = shouldShowRowByExpanded;

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function shouldShowRowByExpanded() {
  var expandedRowKeys = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var parentKeys = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var intersectionKeys = (0, _intersection3["default"])(expandedRowKeys, parentKeys);

  if (intersectionKeys.length === parentKeys.length) {
    return true;
  }

  return false;
}